











import { Component, Vue, Prop } from "vue-property-decorator";

@Component
export default class HibiValue extends Vue {
  @Prop() hibi: any;
  @Prop({ default: false })
  isHasValue: boolean;
  val: number = 0;

  created() {
    this.val = this.hibi;
  }

  getHibiVal() {
    const val = this.val - 3;
    const arrText = ["小", "中", "大"];
    return arrText[val];
  }
}
